<template>
    <div style="margin:30px 0;text-align: center;">
        <img style="width:60px;height:60px" src="../../../assets/imgs/icon-delete.png" />
        <div style="font-size:20px;color:#333333;line-height:27px;margin-top:15px">{{'确认删除该'+name+'吗？'}}</div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            datas:{},
        };
    },
    props: {
        roleData: Object,
        dialogType:String,
        name:String
    },
    watch:{

    },
    methods: {
        Submission(el){
            this.$emit('datamaseg',this.datas,this.dialogType,true)
        }
    },
    mounted(){
        this.datas = {
            id:this.roleData.id
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/views/role/components/deleteMessage.vue